export enum ImeModeKinds {
  // 半角・英語
  Off = 2,
  // 設定しない
  On = 1,
  // 全角
  AllOn = 3,
}
